export const colors = {
    blueVeryLight: '#e5f4fb',
    blueLight: '#2ba8e0',
    blueMid: '#0099e0',
    blueDark: '#006196',
    charcoal: '#00111a',
    graphite: '#494b4d',
    carbon: '#919699',
    success: '#05a34a',
    danger: '#e00808',
    warning: '#ff8200',
    border: '#c8cbcc',
    disabled: '#c8cbcc',
    gray: '#d8d8d8',
    background: '#f3f4f4',
    mist: '#f3f3f3',
}

export const fontFamily = 'MarkPro';

export const lineHeight = '1.33333em';

export const defaultTextStyle = {
    fontFamily,
    lineHeight,
};

export const responsiveWidthBreakpoints = [
    768, // sm
    960, // md
    1284, // lg
];


// WEBPACK FOOTER //
// ./src/settings/theme.js